export enum ParcelActionType {
  FetchParcels = "FETCH_PARCELS",
  FetchParcelsByStatus = "FETCH_PARCEL_BY_STATUS",
  UpdateParcels = "UPDATE_PARCELS",
  RemoveParcels = "REMOVE_PARCELS",
}

export enum OrderActionType {
  FetchOrders = "FETCH_ORDERS",
  OrderByStatus = "FETCH_ORDER_BY_STATUS",
  UpdateOrders = "UPDATE_ORDERS",
  RemoveOrders = "REMOVE_ORDERS",
}

export enum UserActionType {
  CreateUser = "CREATE_USER",
  UpdateUser = "UPDATE_USER",
  FETCH_USERS = "FETCH_USERS",
  DeleteUser = "DELETE_USER",
}

export enum TaskActionType {
  CreateJob = "CREATE_JOB",
  FetchJob = "FETCH_JOB",
  UpdateJob = "UPDATE_JOB",
}

export enum SubTaskActionType {
  CreateSubTask = "CREATE_SUBSTASK",
  UpdateSubTask = "UPDATE_SUBTASK",
  FetchSubtask = "FETCH_SUBTASK",
}

export enum ProductActyionType {
  CreateProduct = "CREATE_PRODUCT",
  UpdateProduct = "UPPDATE_PRODUCT",
  FetchProduct = "FETCH_PRODUCT",
  RemoveProduct = "REMOVE_PRODUCT",
}

export interface ParcelAction {
  type: ParcelActionType | OrderActionType;
  data: any;
  statusKey?: string;
}

export interface SubTaskAction {
  type: SubTaskActionType;
  data: any;
  statusKey?: string;
}
export interface ProductAction {
  type: ProductActyionType;
  data: any;
  statusKey?: string;
}
